import React from 'react';

const ProjectCard = ({detail}) => {
    return (
    <div className="col-md-4 mb-5" style={{width: '18rem'}}>
        <img src={detail.img} className="card-img-top" alt="..."/>
        <div className="card-body text-center" style={{background: 'whitesmoke', borderRadius: '10px', height: '10rem'}}>
            <h5 className="card-title text-color"><b>{detail.title}</b></h5>
            <p className="card-text text-secondary">{detail.text}</p>
        </div>
    </div>
    );
};

export default ProjectCard;